module.exports = __webpack_public_path__ + "media/images/Photos-4160101fa01a7830031ae5ad8e6a7f21.svg";